/** `view` … `unlink` are the colours of the record actions (see components/actions), not states of a message. */
export const allowedStates = ['gray', 'notice', 'warning', 'error', 'success', 'brand', 'disabled', 'view', 'edit', 'delete', 'link', 'unlink'] as const;
export type AllowedState = (typeof allowedStates)[number];
